import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n      display: none;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n      > svg:first-child {\n        transform: translate(-1px, 10px);\n      }\n\n      > svg:last-child {\n        transform: translate(-1px, -10px) rotate(180deg);\n      }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 0;\n  border-radius: 50%;\n  width: 60;\n  height: 60;\n  position: fixed;\n  right: ", ";\n  bottom: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: bg;\n  background-color: text;\n  transition: base;\n  transition-property: color;\n  box-shadow: ", " 0 0 ", ";\n  appearance: none;\n\n  &:focus {\n    outline: none;\n    color: bg;\n  }\n\n  > svg:first-child {\n    transition: transform 200ms ease-in-out;\n    transform: translateX(-1px);\n  }\n\n  > svg:last-child {\n    transition: transform 200ms ease-in-out;\n    transform: translate(-1px) rotate(180deg);\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n      padding-top: 0;\n      position: fixed;\n      height: 100vh;\n      overflow-y: auto;\n      z-index: 2;\n      margin-right: -999;\n      padding-right: 999;\n      background-color: secondary-bg;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n      flex: 0 0 ", ";\n      margin-left: 50;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n      overflow-y: visible;\n      height: auto;\n      pointer-events: auto;\n      transform: none;\n      width: auto;\n      opacity: 1;\n      position: relative;\n      transform: none;\n      flex: 0 0 ", ";\n      margin-left: 16;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n      pointer-events: auto;\n      transform: translateY(0);\n      opacity: 1;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: secondary-bg;\n  border-left: 1;\n  border-color: border;\n  transition: base;\n  transition-property: transform, opacity;\n  position: fixed;\n  opacity: 0;\n  height: 100vh;\n  width: 100vw;\n  transform: translateY(", ");\n  pointer-events: none;\n  overflow-y: auto;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  padding: 0 20 50;\n  overflow: hidden;\n  word-wrap: break-word;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  z-index: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        position: fixed;\n        bottom: 0;\n        left: 0;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      float: right;\n      display: block;\n      width: 200;\n      margin-right: -36;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n\n  ", "\n\n  @media only screen and (min-width: 1560px) {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { css } from '@xstyled/styled-components';
import { up, th } from '@xstyled/system';
import { Grid } from '@smooth-ui/core-sc';
import { Sidebar } from './Sidebar';
import { BaseLayout } from './BaseLayout';
import { Article } from './Article';
import { MenuProvider, MenuConsumer } from './MenuContext';
import ChevronUpSolid from './icons/ChevronUpSolid';
import { CodeFund } from './CodeFund';
var FloatingAd = styled.div(_templateObject(), up('md', css(_templateObject2())), up('xl', css(_templateObject3())));
var Wrapper = styled.div(_templateObject4());
var ArticleContainer = styled.div(_templateObject5());
var SidebarContainer = styled.div(_templateObject6(), th.size(50), function (p) {
  return p.opened && css(_templateObject7());
}, up('sm', css(_templateObject8(), th.size(180))), up('lg', css(_templateObject9(), th.size(230))));
var SidebarWrapper = styled.div(_templateObject10(), up('sm', css(_templateObject11())));
var MenuButton = styled.button(_templateObject12(), th.size(8), th.size(8), th.color('menu-button-shadow'), th.size(20), function (p) {
  return p.active && css(_templateObject13());
}, up('sm', css(_templateObject14())));
export function DocLayout(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return React.createElement(MenuProvider, null, React.createElement(BaseLayout, Object.assign({
    variant: "light"
  }, props), React.createElement(Grid, {
    gutter: 0
  }, React.createElement(Wrapper, null, React.createElement(ArticleContainer, null, React.createElement(Article, null, React.createElement(FloatingAd, null, React.createElement(CodeFund, null)), children)), React.createElement(MenuConsumer, null, function (_ref2) {
    var opened = _ref2.opened,
        toggle = _ref2.toggle;
    return React.createElement(React.Fragment, null, React.createElement(SidebarContainer, {
      opened: opened
    }, React.createElement(SidebarWrapper, null, React.createElement(Sidebar, null))), React.createElement(MenuButton, {
      active: opened,
      onClick: toggle
    }, React.createElement(ChevronUpSolid, {
      width: 15,
      height: 15
    }), React.createElement(ChevronUpSolid, {
      width: 15,
      height: 15
    })));
  })))));
}